export const actionTypeCreateNotice = 'CREATE_NOTICE';
export const actionTypeDeleteNotice = 'DELETE_NOTCE';
export const actionTypeRegisteredNotice = 'REGISTERED_NOTICE';
